import { ApiService } from "../../../../services/api.service"
import { toast } from "react-toastify"
import { LocalStorageUtility } from "../../../../util/localStorageUtility"

export const aliasLogin = (username, setState) => {
  setState(prevState => ({
    ...prevState,
    aliasLoading: true,
  }))
  const payload = [{ username: username }]
  ApiService.post(process.env.ALIAS_LOGIN, payload).then((res: any) => {
    if (res.status === 200 && typeof window !== "undefined") {
      window.location.replace("/dashboard")
      LocalStorageUtility.removeLocalStorage()
    } else {
      toast.error("Something Went Wrong. Please try again later.", {
        toastId: "aliasError",
      })
    }
    setState(prevState => ({
      ...prevState,
      aliasLoading: false,
    }))
  })
}
